//required separate function so that import.meta can be mocked

import { baseUrl } from "config";

export function generateBaseUrl(): string {
  if (
    !import.meta.env.MODE ||
    import.meta.env.DEV ||
    window.location.origin.includes("localhost")
  ) {
    return baseUrl;
  }

  return `${window.location.origin}/api`;
}
